import Pushes from "components/Pushes";

function PushListPage() {
  return <Pushes />;
}

export default PushListPage;
